// admin@ocpus.net
export const stripe_key = 'pk_live_51KlikAGPsYminZ9Ggkrs7wV0O8PN21takBv7eNsGYcidKGa4L1eRnCR95jwqEnbkk6PIndMZW4GFhHMc1HobgNPq0003Ic6c4T'
// export const stripe_key =
// 	'pk_test_51KlikAGPsYminZ9GDfxAihcOZV4N4ulSVZueeiqexfQYzeEfShMvQHAJ91VjT8uVSWGl6C6PO79X1psVul5cIUXR00lZopPvcc';